import React from 'react';
import { Box, Typography } from '@mui/material';

interface LabeledProps {
  label: string;
  value?: React.ReactNode;
}

export function Labeled({ label, value }: LabeledProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Typography variant="caption" color="text.secondary">{label}</Typography>
      <Typography variant="body2" color="text.primary" sx={{ wordBreak: 'break-word' }}>{value ?? '-'}</Typography>
    </Box>
  );
}
